var map = {
  "./cs.json": [
    "Dk",
    [
      "9f"
    ]
  ],
  "./en.json": [
    "HW",
    [
      "t9"
    ]
  ],
  "./pl.json": [
    "n0x",
    [
      "1dt"
    ]
  ],
  "./ru.json": [
    "Ul",
    [
      "yk"
    ]
  ],
  "./tr.json": [
    "SMo",
    [
      "4w"
    ]
  ],
  "./ja.json": [
    "Rk",
    [
      "njc"
    ]
  ],
  "./zh.json": [
    "i4",
    [
      "4n"
    ]
  ],
  "./pt-br.json": [
    "Nfz",
    [
      "bu"
    ]
  ],
  "./de.json": [
    "Ry",
    [
      "nno"
    ]
  ],
  "./es.json": [
    "ZV",
    [
      "vca"
    ]
  ],
  "./fr.json": [
    "Nq",
    [
      "j5"
    ]
  ],
  "./it.json": [
    "ywH",
    [
      "we"
    ]
  ],
  "./ko.json": [
    "Vly",
    [
      "rog"
    ]
  ],
  "./pt.json": [
    "Aod",
    [
      "qc"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "JK";
module.exports = __rspack_async_context;
